/* Ishira hero slider (THEME-012). No dependencies. Autoplay pauses on hover, focus, hidden tab, reduced motion and the pause button. */
(function () {
  'use strict';
  function qsa(el, s) { return Array.prototype.slice.call(el.querySelectorAll(s)); }

  function init(root) {
    if (root._ishHs) return; root._ishHs = true;
    var stage = root.querySelector('[data-hs-stage]');
    var slides = qsa(root, '[data-hs-slide]');
    var dots = qsa(root, '[data-hs-dot]');
    var prev = root.querySelector('[data-hs-prev]');
    var next = root.querySelector('[data-hs-next]');
    var toggle = root.querySelector('[data-hs-toggle]');
    var n = slides.length;
    if (n < 2) return;
    var i = 0, timer = null, userPaused = false, hover = false, focus = false;
    var interval = Math.max(5000, parseInt(root.getAttribute('data-interval'), 10) || 6000);
    var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    if (mq && mq.matches) userPaused = true;

    function show(k, byUser) {
      k = (k + n) % n;
      if (k === i) return;
      slides[i].classList.remove('is-active');
      slides[i].setAttribute('aria-hidden', 'true');
      slides[i].setAttribute('inert', '');
      slides[k].classList.add('is-active');
      slides[k].removeAttribute('aria-hidden');
      slides[k].removeAttribute('inert');
      dots.forEach(function (d, j) { d.setAttribute('aria-current', j === k ? 'true' : 'false'); });
      if (prev) prev.setAttribute('aria-controls', slides[(k - 1 + n) % n].id);
      if (next) next.setAttribute('aria-controls', slides[(k + 1) % n].id);
      i = k;
      if (byUser) stage.setAttribute('aria-live', 'polite');
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function sync() {
      stop();
      var run = !userPaused && !hover && !focus && !document.hidden;
      if (run) {
        stage.setAttribute('aria-live', 'off');
        timer = setInterval(function () { show(i + 1, false); }, interval);
      }
    }
    function setPaused(p) {
      userPaused = p;
      if (toggle) {
        toggle.setAttribute('aria-pressed', p ? 'true' : 'false');
        toggle.setAttribute('aria-label', p ? 'Play slideshow' : 'Pause slideshow');
        var a = toggle.querySelector('[data-hs-ico-pause]'), b = toggle.querySelector('[data-hs-ico-play]');
        if (a) { if (p) a.setAttribute('hidden', ''); else a.removeAttribute('hidden'); }
        if (b) { if (p) b.removeAttribute('hidden'); else b.setAttribute('hidden', ''); }
      }
      sync();
    }

    if (prev) prev.addEventListener('click', function () { show(i - 1, true); sync(); });
    if (next) next.addEventListener('click', function () { show(i + 1, true); sync(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-hs-dot'), 10), true); sync(); }); });
    if (toggle) toggle.addEventListener('click', function () { setPaused(!userPaused); });

    root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { hover = true; sync(); } });
    root.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { hover = false; sync(); } });
    root.addEventListener('focusin', function () { focus = true; sync(); });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) { focus = false; sync(); } });
    root.addEventListener('keydown', function (e) {
      if (!e.target.closest || !e.target.closest('.ish-hs__nav')) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(i - 1, true); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); show(i + 1, true); }
    });
    // Swipe on touch screens (horizontal only, does not block vertical scroll).
    var x0 = null, y0 = null;
    stage.addEventListener('touchstart', function (e) { var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return; var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0; x0 = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) { show(dx < 0 ? i + 1 : i - 1, true); sync(); }
    }, { passive: true });
    document.addEventListener('visibilitychange', sync);
    if (mq && mq.addEventListener) mq.addEventListener('change', function (e) { if (e.matches) setPaused(true); });

    // After the page has loaded, fetch the other slides' images at low priority so they are ready before they appear.
    function warm() { setTimeout(function () { qsa(root, 'img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; }); }, 1500); }
    if (document.readyState === 'complete') warm(); else window.addEventListener('load', warm);

    root.classList.add('is-ready');
    setPaused(userPaused);
  }

  function boot(e) {
    var scope = (e && e.target && e.target.querySelectorAll) ? e.target : document;
    qsa(scope, '[data-ish-hs]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest && e.target.closest('[data-ish-hs]');
    if (root && root._ishHs) { /* theme editor: show the selected slide */
      var slides = qsa(root, '[data-hs-slide]'); var k = slides.indexOf(e.target);
      var dot = root.querySelector('[data-hs-dot="' + k + '"]'); if (dot) dot.click();
    }
  });
})();
